import { createContext } from 'react'

export const NavbarRenderedContext = createContext(false)
